import cashPriceObjectOPLECL from './touchpoints/cashPriceObjectOPLECL';
import cashPriceObjectOPLEFL from './touchpoints/cashPriceObjectOPLEFL';
import cashPriceObjectSUB from './touchpoints/cashPriceObjectSUB';

const classes = {
    cashPriceObjectOPLECL: cashPriceObjectOPLECL,
    cashPriceObjectOPLEFL: cashPriceObjectOPLEFL,
    cashPriceObjectSUB: cashPriceObjectSUB
};

export class cashPriceProxy {

    constructor (className) {
        // eslint-disable-next-line
        return (new classes[className]);
    }
}
